import { useContext } from 'react';

import TabContext, { TabContextValues } from './context';

const useTabContext = (): TabContextValues => useContext(TabContext);

export default useTabContext;

export * from './context';
export * from './provider';
